export default __webpack_public_path__ + "static/media/draft.ba7b1a0a.png";